<template>
  <div
    class="absolute left-0 right-0 top-0 grid h-12 w-full auto-cols-fr grid-flow-col justify-center gap-x-1 bg-secondary-purple px-2 font-semibold text-white"
    style="z-index: 100"
  >
    <div></div>
    <div class="flex items-center justify-center text-base">
      <div class="flex h-12 w-12 items-center justify-center">
        <icon-base
          icon="sandbox-white"
          width="20"
          height="20"
          viewBox="0 0 20 20"
        />
      </div>
      <div>
        {{ $t("ORGANIZATION.TEST_MODE.ALERT_MESSAGE") }}
      </div>
    </div>
    <div class="mr-9 flex items-center justify-end">
      <access-control :lendflow="true" :clients="true">
        <test-mode-modal v-if="showModal" :close="() => (showModal = false)" />
        <a href="" @click.prevent="showModal = true">
          {{ $t("ORGANIZATION.TEST_MODE.EXIT_TEXT") }}
        </a>
      </access-control>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import TestModeModal from "@/components/sidebar/TestModeModal.vue";
const showModal = ref(false);
</script>
